import { useBnplCapabilities } from 'hooks/payment/bnplCapabilities/useBnplCapabilities';
import { usePaymentStatus } from 'hooks/payment/status/usePaymentStatus';
import { usePreferences } from 'hooks/preferences/usePreferences';
import { useWebsite } from 'hooks/website/useWebsite';

import { useBnplSettingsFeatureFlag } from 'routes/invoices/useBnplFeatureFlag';

const BNPL_CAPABILITIES_COUNT = 3;

export const useBnplPromo = () => {
  const bnplSettingsFF = useBnplSettingsFeatureFlag();

  const { showBNPLPrices } = usePreferences();
  const { slug } = useWebsite();
  const { data: paymentStatus, isLoading: isPaymentStatusLoading } =
    usePaymentStatus(slug);
  const { data: bnplCapabilitiesData, isLoading: isBnplCapabilitiesLoading } =
    useBnplCapabilities();

  const enableBNPLPromo = Boolean(bnplSettingsFF.isEnabled && showBNPLPrices);
  const canTakePayment = Boolean(
    paymentStatus && paymentStatus?.payments_status !== 'inactive',
  );

  const dynamicPaymentMethodsEnabled =
    bnplSettingsFF.isDynamicPaymentMethodsEnabled;

  // If dynamic payment methods are enabled, we only need one BNPL provider
  // Otherwise, we need all BNPL providers
  const minRequiredProvidersCount = dynamicPaymentMethodsEnabled
    ? 1
    : BNPL_CAPABILITIES_COUNT;

  const bnplCapabilities = bnplCapabilitiesData?.data ?? [];
  const hasBNPLCapabilities =
    bnplCapabilities.length >= minRequiredProvidersCount;

  return {
    isLoading:
      showBNPLPrices &&
      (bnplSettingsFF.isLoading ||
        isPaymentStatusLoading ||
        isBnplCapabilitiesLoading),
    isEnabled: enableBNPLPromo && canTakePayment && hasBNPLCapabilities,
    bnplCapabilities,
  };
};
